export const imageStyles = {
    desktop: {
        defaultWidth: '100px',
        defaultHeight: '100px',
    },
}
